/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect} from "react";

import useTypedSelector from "@Services/Hooks/UseTypedSelector";


import ApplicationApiContext from "@Contexts/Api";


import {Button, Col, Row} from "react-bootstrap";


import DefaultMessageComponent from "@Components/UI/Communicates/Messages/Default";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import FormFieldComponent from "@Components/UI/Forms/Field";
import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldsGroupHeaderComponent from "@Components/UI/Forms/Group/Header";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";


import REST_API_REQUEST from "@Services/Utilities/Requests";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";


interface VerificationFormErrorsInterface {
    process?: string | null;
    pinNumber?: string | null;
    smsCode?: string | null;
}


type SettingsSMSCodeVerificationProps = {
    verificationStatusHandler(response: any): any;
    requestStep1URL?: string;
    requestStep2URL?: string;
};


export const SettingsSMSCodeVerificationComponent: React.FC<SettingsSMSCodeVerificationProps> = ({
    verificationStatusHandler,
    requestStep1URL = "/User/Verification/Initialization",
    requestStep2URL = "/User/Verification/Finalization"
}): JSX.Element | null => {


    /** @type {UserInterface | null} Application Logged User (from Global Store Object */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @var {REST_API_URL} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const REST_API_REQUEST_STATUS = useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    const [verificationFormOperationGuid, setVerificationFormOperationGuid] = useState<string>("");

    const [verificationFormErrors, setVerificationFormErrors] = useState<VerificationFormErrorsInterface>({});
    const [verificationFormStep, setVerificationFormStep] = useState<1 | 2>(1);

    const [verificationPINNumber, setVerificationPINNumber] = useState<string>("");
    const [verificationSMSCode, setVerificationSMSCode] = useState<string>("");
    const [verificationSMSCodeValidDate, setVerificationSMSCodeValidDate] = useState<any>({code: 1, time: 300});
    const [verificationSMSCodeNumber, setVerificationSMSCodeNumber] = useState<number>(1);
    const [verificationSMSCodeNumberLockStatus, setVerificationSMSCodeNumberLockStatus] = useState<boolean>(false);

    const changeVerificationPINNumber = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const pinCode = e.target.value;
        // if (pinCode.length === 4 && !isNaN(+pinCode)) setVerificationFormErrors({...verificationFormErrors, pinNumber: null});
        setVerificationPINNumber(pinCode);
    };

    const changeVerificationSMSCode = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const smsCode = e.target.value;
        // if (smsCode.length === 6 && !isNaN(+smsCode)) setVerificationFormErrors({...verificationFormErrors, smsCode: null});
        setVerificationSMSCode(smsCode);
    };

    useEffect(() => {
        return () => {
            setVerificationFormErrors({});
            setVerificationFormStep(1);
            setVerificationPINNumber("");
            setVerificationSMSCode("");
            setVerificationSMSCodeNumberLockStatus(false);
        };
    }, []);


    const [leftSmsCodeValidTime, setLeftSmsCodeValidTime] = useState<number>(0);
    const [activeCountDown, setActiveCountDown] = useState<any>(null);


    useEffect(() => {
        if (leftSmsCodeValidTime > 0) {
            if (activeCountDown) window.clearTimeout(activeCountDown);
            const interval = setTimeout(() => setLeftSmsCodeValidTime(leftSmsCodeValidTime - 1), 1000);;
            setActiveCountDown(interval);
        }
    }, [leftSmsCodeValidTime]);


    useEffect(() => {
        if (activeCountDown) window.clearTimeout(activeCountDown);
        if (verificationFormStep !== 2) return;
        if (verificationSMSCodeValidDate === 0) return;
        setLeftSmsCodeValidTime(verificationSMSCodeValidDate.time);
    }, [verificationSMSCodeValidDate]);


    const leftMinutes = Math.floor(leftSmsCodeValidTime / 60) || 0
    const leftSeconds = leftSmsCodeValidTime % 60 || 0;

    const formattedTime = `${(leftMinutes < 10 ? "0" : "" ) + leftMinutes.toString()}:${(leftSeconds < 10 ? "0" : "" ) + leftSeconds.toString()}`;


    const [enterKeyPressCount, setEnterKeyPressCount] = useState<number>(0);

    useEffect(() => {
        let n = 0;
        const HANDLER = (e: KeyboardEvent) => {
            if (e.key === "Enter") setEnterKeyPressCount(++n);
        }
        document.addEventListener("keydown", HANDLER);
        return () => document.removeEventListener("keydown", HANDLER);
    }, []);

    useEffect(() => {
        if (enterKeyPressCount === 0) return;
        verificationCodeSubmitHandler();
    }, [enterKeyPressCount]);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;


    const verificationCodeSubmitHandler = () => {

        let formError: boolean;

        setVerificationFormErrors({...verificationFormErrors, process: null});

        switch (verificationFormStep) {
            case 1:
                formError = !validatePinCodeStep();
                // formError = false;
                break;
            case 2:
                formError = !validateSMSCodeStep();
                break;
            default:
                formError = false;
        }

        if (formError) return null;

    };

    const validatePinCodeStep = () => {
        // if (verificationPINNumber.length !== 4 || isNaN(+verificationPINNumber)) {
        //     setVerificationFormErrors({...verificationFormErrors, pinNumber: "PIN ma nieprawidłowy format", process: null})
        //     return false;
        // }
        VERIFICATION_CODE_REQUEST_HANDLER();
        return true;
    };

    const validateSMSCodeStep = () => {
        // if (verificationSMSCode.length !== 6 || isNaN(+verificationSMSCode)) {
        //     setVerificationFormErrors({...verificationFormErrors, smsCode: "Kod ma nieprawidłowy format", process: null})
        //     return false;
        // }
        VERIFICATION_CODE_REQUEST_HANDLER();
        return true;
    };


    const VERIFICATION_CODE_REQUEST_HANDLER = async () => {

        if (!REST_API_URL || !LOGGED_USER || !LOGGED_USER?.userID) return null;

        let RESPONSE: any;

        let API_REQUEST_URL: string = REST_API_URL;
        let API_REQUEST_DATA: any;

        switch (verificationFormStep) {
            case 1:
                API_REQUEST_URL += requestStep1URL;
                API_REQUEST_DATA = {
                    UserId: LOGGED_USER?.userID,
                    CardPIN: verificationPINNumber
                };
                break;
            case 2:
                API_REQUEST_URL += requestStep2URL;
                API_REQUEST_DATA = {
                    UserId: LOGGED_USER?.userID,
                    OperationGUID: verificationFormOperationGuid,
                    VerificationCode: verificationSMSCode
                };
                break;
            default:
                return null;
        }

        try {

            const AUTHORIZATION_RESPONSE = await REST_API_REQUEST(
                API_REQUEST_URL,
                API_REQUEST_DATA,
                REST_API_REQUEST_TOKEN
            );

            if (AUTHORIZATION_RESPONSE.status !== 200 && AUTHORIZATION_RESPONSE.status !== 204) {
                RESPONSE = {error: true, message: (await AUTHORIZATION_RESPONSE.json())?.UserMessage};
                if (verificationFormStep === 2 && AUTHORIZATION_RESPONSE.status === 409) {
                    setVerificationSMSCodeNumberLockStatus(true);
                }
            } else {
                setVerificationFormStep(verificationFormStep === 1 ? 2 : 1);
                switch (verificationFormStep) {
                    case 1:
                        const CONTENT: any = await AUTHORIZATION_RESPONSE?.json();
                        setVerificationFormOperationGuid(CONTENT?.OperationGUID);
                        const smsCodeValidDateTime = new Date(CONTENT?.VerificationCodeValidDate);
                        const smsCodeValidLeftTime = Math.ceil((smsCodeValidDateTime.getTime() - (new Date()).getTime()) / 1000);
                        setVerificationSMSCodeValidDate({code: +CONTENT?.VerificationCodeNo || 1, time: smsCodeValidLeftTime});
                        setVerificationSMSCodeNumber(+CONTENT?.VerificationCodeNo || 1);
                        break;
                    case 2:
                        verificationStatusHandler({OperationGUID: verificationFormOperationGuid});
                        break;
                    default:
                        return null;
                }
            }

        } catch (e) {
            console.log(e)
            RESPONSE = {error: true, message: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"};
        }

        if (RESPONSE?.error) setVerificationFormErrors({...verificationFormErrors, process: RESPONSE?.message});

        return RESPONSE;

    };


    const GENERATE_VERIFICATION_CODE = async () => {

        try {

            const VERIFICATION_CODE_RESPONSE = await REST_API_REQUEST(
                `${REST_API_URL}/User/GenerateVerificationCode`,
                {
                    UserId: LOGGED_USER?.userID,
                    OperationGUID: verificationFormOperationGuid
                },
                REST_API_REQUEST_TOKEN
            )

            const CONTENT: any = await VERIFICATION_CODE_RESPONSE.json();

            if (VERIFICATION_CODE_RESPONSE.status === 200) {
                setVerificationSMSCode("");
                setVerificationSMSCodeNumberLockStatus(false);
                const smsCodeValidDateTime = new Date(CONTENT?.VerificationCodeValidDate);
                const smsCodeValidLeftTime = Math.ceil((smsCodeValidDateTime.getTime() - (new Date()).getTime()) / 1000);
                setVerificationSMSCodeValidDate({code: +CONTENT?.VerificationCodeNo || 1, time: smsCodeValidLeftTime});
                setVerificationSMSCodeNumber(+CONTENT?.VerificationCodeNo || 1);
                setVerificationFormErrors({process: null});
            } else {
                setVerificationFormErrors({process: CONTENT?.UserMessage});
                if (activeCountDown) window.clearTimeout(activeCountDown);
                setActiveCountDown(null);
                setLeftSmsCodeValidTime(-1);
            }

        } catch (e) {
            setVerificationFormErrors({process: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            if (activeCountDown) window.clearTimeout(activeCountDown);
            setActiveCountDown(null);
            setLeftSmsCodeValidTime(-1);
        }

    };


    return (
        <Col xs={12} className={`verification-form-component user-form-component`}>
            <Row className={`verification-form user-form`}>

                <FormFieldsGroupComponent>

                    <FormFieldsGroupHeaderComponent
                        headerText={verificationFormStep === 1 ? `Zweryfikuj swój PIN` : `Wprowadź kod weryfikacyjny`}
                    />

                    <FormFieldsGroupFieldsComponent>

                        <>
                        {verificationFormStep === 1 &&
	                    <FormFieldComponent
		                    fieldValue={verificationPINNumber} fieldValueHandler={changeVerificationPINNumber}
		                    fieldType={"password"}
		                    fieldLabel={"PIN do karty kierowcy"}
		                    fieldError={verificationFormErrors.pinNumber}
		                    fieldLegend={"Aktualny PIN, używany przez Ciebie na kiosku MM"}
	                    />
                        }
                        </>

                        <>
                        {verificationFormStep === 2 && !verificationSMSCodeNumberLockStatus &&
                        <FormFieldComponent
                            fieldValue={verificationSMSCode} fieldValueHandler={changeVerificationSMSCode}
                            fieldType={"number"}
                            fieldLabel={`Podaj Kod weryfikacyjny nr ${verificationSMSCodeNumber}`}
                            fieldError={verificationFormErrors.smsCode}
                            fieldLegend={leftSmsCodeValidTime > 0 ? `Pozostały czas: ${formattedTime}` : null}
                            fieldDisabledStatus={!(leftSmsCodeValidTime > 0)}
                        />
                        }
                        </>

                        <>
                        {leftSmsCodeValidTime !== -1 && !verificationSMSCodeNumberLockStatus &&
                        <Col xs={12}>
	                        <DefaultMessageComponent messageText={"Na numer telefonu zarejestrowany w CDOK zostanie wysłany kod weryfikacyjny"} />
                        </Col>
                        }
                        </>


                    </FormFieldsGroupFieldsComponent>

                    <>
                    {!!verificationFormErrors?.process &&
                    <ErrorMessageComponent messageText={verificationFormErrors?.process} />
                    }
                    </>

                    <>
                    {leftSmsCodeValidTime !== -1 && !verificationSMSCodeNumberLockStatus &&
                    <DefaultFormButton
                        buttonText={`Dalej`}
                        clickHandler={() => verificationCodeSubmitHandler()}
                        controlId={`user-verification-submit`}
                        disabled={!!REST_API_REQUEST_STATUS}
                        cssClasses={`user-verification-submit`}
                    />
                    }
                    </>

                    <>
                    {leftSmsCodeValidTime !== -1 && verificationFormStep === 2 &&
                    <Col xs={12} style={{marginTop: 30, textAlign: "center"}}>
                        <Button size={"sm"} onClick={GENERATE_VERIFICATION_CODE}>
                            <span>{`Wygeneruj kod ponownie`}</span>
                        </Button>
                    </Col>
                    }
                    </>

                </FormFieldsGroupComponent>

            </Row>
        </Col>
    );

};


export default SettingsSMSCodeVerificationComponent;
